import { z } from 'zod'

export const COACHING_SHELL_COHORT_CONTRACT_VERSION = '1.0.0' as const
export const coachingShellCohortResponseSchema = z.unknown()
export type CoachingShellCohortResponse = z.infer<typeof coachingShellCohortResponseSchema>
